module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['steps', 'children' + _vm.steps.length]
  }, _vm._l((_vm.steps), function(item, $index) {
    return _c('div', {
      key: $index,
      class: ['step', $index === (_vm.step - 1) ? 'active' : '', $index < (_vm.step - 1) ? 'finished' : '', item.state]
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ($index !== 0),
        expression: "$index !== 0"
      }],
      staticClass: "arrow"
    }), _vm._v(" "), _c('i', {
      class: ['icon', item.key]
    }), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "sub-text"
    }, [_vm._v(_vm._s(item.date))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a953c190"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StepsBar.vue
// module id = 766
// module chunks = 0